import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Button } from '../../../../../../components/Button';
import { ButtonGroup, ButtonGroupItem } from '../../../../../../components/ButtonGroup';
import { trackEvent } from '@99designs/tracking';

interface Props {
    showEnableBrowserNotificationsPrompt: boolean;
    hasDeclined: boolean;
    browserNotificationsEnabled?: boolean;
    browserNotificationsBlocked?: boolean;
    browserNotificationsSupported?: boolean;
    handleEnableButtonClick: (caller?: string) => void;
    handleDeclineButtonClick?: () => void;
    pending?: boolean;
}

const showPrompt = ({
    showEnableBrowserNotificationsPrompt,
    hasDeclined,
    browserNotificationsEnabled,
    browserNotificationsBlocked,
    browserNotificationsSupported,
}: Props) => {
    if (
        !browserNotificationsSupported ||
        browserNotificationsEnabled ||
        browserNotificationsBlocked ||
        !showEnableBrowserNotificationsPrompt ||
        hasDeclined
    ) {
        return false;
    }

    trackEvent('Viewed Enable Notifications Prompt');

    return true;
};

const PromptContent = (props: Props) =>
    showPrompt(props) ? (
        <div className="onsite-notifications__header__prompt">
            <p className="paragraph paragraph--no-margin paragrap--small onsite-notifications__prompt__text">
                <FormattedMessage
                    id="Enable browser notificatons?"
                    defaultMessage="Enable browser notificatons?"
                />
                &nbsp;
                <FormattedMessage
                    id="Get updates on your device, even when 99designs is closed."
                    defaultMessage="Get updates on your device, even when 99designs is closed."
                />
            </p>
            <ButtonGroup className="onsite-notifications__header__prompt__button-group">
                <ButtonGroupItem>
                    <Button
                        isDisabled={props.pending}
                        onClick={() =>
                            props.handleEnableButtonClick('Notifications dropdown prompt')
                        }
                        variations={['small', 'primary', 'chameleon']}
                    >
                        <FormattedMessage id="Yes please" defaultMessage="Yes please" />
                    </Button>
                </ButtonGroupItem>
                <ButtonGroupItem>
                    <Button
                        isDisabled={props.pending}
                        onClick={props.handleDeclineButtonClick}
                        variations={['small', 'chameleon', 'secondary']}
                    >
                        <FormattedMessage id="No thanks" defaultMessage="No thanks" />
                    </Button>
                </ButtonGroupItem>
            </ButtonGroup>
        </div>
    ) : null;

export default PromptContent;
